import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import MyRequests from './pages/MyRequests';
import ExtensionsRequest from './pages/ExtensionsRequest';
import AcademicChanges from './pages/AcademicChanges';
import TravelRequest from './pages/TravelRequest';
import LeaveRequest from './pages/LeaveRequest';
import ExpenseReimbursement from './pages/ExpenseReimbursement';
import MarketingRequest from './pages/MarketingRequest';
import WFHChecklist from './pages/WFHChecklist';
import RequestDetail from './pages/RequestDetail';
import Reports from './pages/Reports';
import ProtectedRoute from './components/ProtectedRoute';
import { msalConfig } from './authConfig';
import './app.css';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle redirect responses
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      // Login redirect successful
    }
  }).catch((error) => {
    console.error('Redirect error:', error);
  });
});

// Create MUI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#0078d4', // Microsoft blue
    },
    secondary: {
      main: '#5c2d91', // Microsoft purple
    },
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Arial", sans-serif',
  },
});

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-requests"
              element={
                <ProtectedRoute>
                  <MyRequests />
                </ProtectedRoute>
              }
            />
            <Route
              path="/extensions-request"
              element={
                <ProtectedRoute>
                  <ExtensionsRequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/academic-changes"
              element={
                <ProtectedRoute>
                  <AcademicChanges />
                </ProtectedRoute>
              }
            />
            <Route
              path="/travel-request"
              element={
                <ProtectedRoute>
                  <TravelRequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leave-request"
              element={
                <ProtectedRoute>
                  <LeaveRequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/expense-reimbursement"
              element={
                <ProtectedRoute>
                  <ExpenseReimbursement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/marketing-request"
              element={
                <ProtectedRoute>
                  <MarketingRequest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/wfh-checklist"
              element={
                <ProtectedRoute>
                  <WFHChecklist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request/:id"
              element={
                <ProtectedRoute>
                  <RequestDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
        <Toaster position="top-right" />
      </ThemeProvider>
    </MsalProvider>
  );
}

export default App;
